import { render } from "./business-cards.vue?vue&type=template&id=cea8ed48&scoped=true"
import script from "./business-cards.vue?vue&type=script&lang=js"
export * from "./business-cards.vue?vue&type=script&lang=js"

import "./business-cards.vue?vue&type=style&index=0&id=cea8ed48&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea8ed48"]])

export default __exports__